<template>
  <section class="p-2">
    <v-card>
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">
          <span class="font-weight-bold">{{ partnerName }} </span>-
          <span>Acive Bank List</span>
        </div>
        <!-- <div>
          <bread-crumb :bread-crumbs="['partnerBank Summary']" />
        </div> -->
      </v-card-title>

      <v-data-table fixed-header  height="55vh"
        :headers="activeHeaders"
        :items="ActiveBankSummary"
        :search="Banksearch"
        :loading="loader"
        show-select
        dense
        :single-select="singleActiveSelect"
        v-model="selectedActiveItems"
        item-key="name"
      >
        <template v-slot:item.branch="{ item }">
          <a class="text-decoration-underline" @click="navBranchList(item)">
            {{ item.branch }}
          </a>
        </template>
        <template v-slot:item.action="{ item }">
          <div class="d-flex">
            <v-btn
              depressed
              rounded
              x-small
              @click="openBlockDialog(item)"
              color="success"
              title="Activate"
              class="text-capitalize me-3"
              v-if="!item.is_active"
            >
              <v-icon small class="me-1">mdi-check</v-icon>Activate
            </v-btn>
            <v-btn
              depressed
              rounded
              x-small
              @click="openBlockDialog(item)"
              outlined
              text
              color="primary"
              class="text-capitalize me-3"
              title="Deactivate"
              v-else
            >
              <v-icon small class="me-1">mdi-close-circle</v-icon> Deactivate
            </v-btn>
          </div>
        </template>

        <template v-slot:top>
          <v-divider class="p-0 m-0 primary--text"></v-divider>

          <div class="d-flex mt-5">
            <v-btn
              depressed
              rounded
              color="primary"
              class="text-capitalize me-3 mt-1 ml-2"
              outlined
              :disabled="!showActiveButton"
              small
              @click="openFormDialog('Deactivate')"
            >
              <v-icon small>mdi-content-save-edit-outline</v-icon> Deactivate
            </v-btn>
            <v-btn
              depressed
              rounded
              @click="downloadExcelsheet"
              color="primary"
              small
              class="me-3 ml-2 mt-1"
              ><v-icon small>mdi-file-excel-outline</v-icon>Export
            </v-btn>
            <v-spacer> </v-spacer>
            <v-spacer> </v-spacer>
            <v-form ref="searchForm" v-model="valid">
              <v-autocomplete
                v-model="paymentMode"
                class="rounded ml-2"
                dense
                outlined
                placeholder="Payment Mode"
                item-text="txt"
                item-value="val"
                :items="method_options"
                :rules="paymentModeRules"
              ></v-autocomplete>
            </v-form>
            <v-btn
              depressed
              rounded
              small
              class="text-capitalize me-2 ms-2 mt-1 text-decoration-none"
              color="primary"
              @click="getAllActiveBanks()"
              >Get Results</v-btn
            >

            <v-text-field
              v-model="Banksearch"
              append-icon="mdi-magnify"
              label="Type here to filter the table data."
              hide-details
              class="me-4 mb-5"
              dense
              clearable
            ></v-text-field>
          </div>
        </template>
      </v-data-table>
      <!-- ------------------------------------------ -->

      <v-data-table fixed-header  height="55vh"
        :headers="dessertHeaders"
        :items="BankSummary"
        :search="search"
        :loading="loader"
        show-select
        dense
        :single-select="singleSelect"
        v-model="selectedItems"
        item-key="name"
      >
        <template v-slot:item.action="{ item }">
          <div class="d-flex">
            <v-btn
              rounded
              x-small
              @click="openBlockDialog(item)"
              color="success"
              depressed
              title="Activate"
              class="text-capitalize me-3"
              outlined
              v-if="!item.is_active"
            >
              <v-icon small class="me-1">mdi-check-circle</v-icon>Activate
            </v-btn>
            <v-btn
              depressed
              rounded
              x-small
              @click="openBlockDialog(item)"
              
              color="primary"
              class="text-capitalize me-3"
              title="Deactivate"
              v-else
            >
              <v-icon small class="me-1">mdi-close-circle</v-icon> Deactivate
            </v-btn>
          </div>
        </template>

        <template v-slot:top>
          <v-divider class="p-0 pb-3 m-0 primary--text"></v-divider>
          <p class="font-weight-bold ms-3">De-Active Bank List:</p>
          <div class="d-flex mt-5">
            <v-btn
              depressed
              rounded
              color="primary"
              class="text-capitalize me-3 mt-1 ml-2"
              outlined
              :disabled="!showButton"
              small
              @click="openFormDialog('Activate')"
            >
              <v-icon small>mdi-content-save-edit-outline</v-icon> Activate
            </v-btn>
            <v-btn
              depressed
              rounded
              @click="downloadExcelsheet"
              color="primary"
              small
              class="me-3 ml-2 mt-1"
              ><v-icon small>mdi-file-excel-outline</v-icon>Export
            </v-btn>
            <v-spacer> </v-spacer>
            <v-spacer> </v-spacer>
            <v-form ref="searchForm" v-model="valid">
              <v-autocomplete
                v-model="inactivePaymentMode"
                class="rounded ml-2"
                dense
                outlined
                placeholder="Payment Mode"
                item-text="txt"
                item-value="val"
                :items="method_options"
                :rules="paymentModeRules"
              ></v-autocomplete>
            </v-form>
            <v-btn
              depressed
              rounded
              small
              class="text-capitalize me-2 ms-2 mt-1 text-decoration-none"
              color="primary"
              @click="getAllBanks()"
              >Get Results</v-btn
            >

            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to filter the table data."
              hide-details
              class="me-4 mb-5"
              dense
              clearable
            ></v-text-field>
          </div>
        </template>
      </v-data-table>
      <v-dialog persistent v-model="showBlockDialog" width="500">
        <v-card>
          <v-card-title class="border border-bottom"
            >Update Bank Status</v-card-title
          >
          <v-card-text class="h5 py-3"
            >Are you sure you want to {{ title_text }}?</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              rounded
              small
              color="primary"
              outlined
              @click="confirmBlock(isActive ? false : true)"
            >
              {{ title_text }}<v-icon>mdi-check</v-icon>
            </v-btn>
            <v-btn
              depressed
              rounded
              small
              color="primary"
              outlined
              @click="showBlockDialog = false"
            >
              Close<v-icon>mdi-close-circle</v-icon></v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <OverlayPageVue :showOverlay="loader" />
    </v-card>
  </section>
</template>

<script>
import OverlayPageVue from "@/utils/OverlayPage.vue";
// import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import partnerService from "@/services/partnerService/partnerService.js";
import { masterBankandBranch } from "@/utils/validation.js";
import alerts from "@/mixins/alerts";
export default {
  mixins: [alerts],
  name: "partnerBank Summary",
  data() {
    return {
      ...masterBankandBranch,
      search: "",
      Banksearch: "",
      showBlockDialog: false,
      isActive: null,
      blockId: null,
      loader: false,
      partnerName: "",
      title_text: "",
      paymentMode: "B",
      inactivePaymentMode: "B",
      valid: true,
      singleSelect: false,
      singleActiveSelect: false,
      selectedItems: [],
      selectedActiveItems: [],
      method_options: [],
      activeItem: [],
      updateBank: {},
      dessertHeaders: [
        {
          text: "Country",
          sortable: false,
          value: "country_name",
        },
        { text: "Location ID", value: "source_id" },
        { text: "Bank Name", value: "name" },
        { text: "Payment Mode", value: "payment_mode" },
        { text: "Activate", value: "action", sortable: false },
      ],
      BankSummary: [],
      activeHeaders: [
        {
          text: "Country",
          sortable: false,
          value: "country_name",
        },
        { text: "Location ID", value: "source_id" },
        { text: "Bank Name", value: "name" },
        { text: "External Bank ID", value: "bank_id" },
        // { text: "Branch", value: "branch" },
        { text: "Payment Mode", value: "payment_mode" },
        { text: "Activate", value: "action", sortable: false },
      ],
      ActiveBankSummary: [],
    };
  },
  components: {
    // BreadCrumb,
    OverlayPageVue,
  },
  mounted() {
    this.partnerName = this.$route.query.name;
    this.partnerPaymentMode();
    if (this.$route.query.parent_partner_id && this.paymentMode) {
      this.getAllData();
    }
  },
  computed: {
    showButton() {
      return this.selectedItems.length > 0;
    },
    showActiveButton() {
      return this.selectedActiveItems.length > 0;
    },
    allValuesSelected() {
      return this.selectedItems.length === this.BankSummary.length;
    },
    allActiveValuesSelected() {
      return this.selectedActiveItems.length === this.ActiveBankSummary.length;
    },
  },
  methods: {
    stoploader() {
      setTimeout(() => {
        this.loader = false;
      }, 400);
    },

    openFormDialog(item) {
      this.showBlockDialog = true;
      if (item == "Activate") {
        this.title_text = item;
        this.isActive = true;
      } else if (item == "Deactivate") {
        this.isActive = false;
        this.title_text = item;
      }
    },

    openBlockDialog(item) {
      this.title_text = !item.is_active ? "Activate" : "Deactivate";
      this.showBlockDialog = true;
      this.isActive = !item.is_active;
      console.log(this.isActive);
      this.activeItem.push(item.map_id);
    },

    closeDialog() {
      this.showBlockDialog = false;
      this.selectedItems = [];
      this.selectedActiveItems = [];
    },

    async confirmBlock() {
      if (this.isActive == true) {
        this.selectedItems = this.selectedItems.map((ele) => ele.map_id);
        this.updateBank = {
          partner_id: this.$route.query.parent_partner_id,
          map_id: this.selectedItems,
          is_active: this.isActive,
        };
      } else if (this.isActive == false) {
        this.selectedActiveItems = this.selectedActiveItems.map(
          (ele) => ele.map_id
        );
        this.updateBank = {
          partner_id: this.$route.query.parent_partner_id,
          map_id: this.selectedActiveItems,
          is_active: this.isActive,
        };
      }
      if (this.activeItem.length) {
        this.updateBank = {
          partner_id: this.$route.query.parent_partner_id,
          map_id: this.activeItem,
          is_active: this.isActive,
        };
      }
      this.loader = true;
      try {
        const response = await partnerService.updateStatus(this.updateBank);
        if (response.data.status_code === 200) {
          this.showAlertSuccess(response.data.message);
          this.stoploader();
          this.getAllData();
          this.activeItem = [];
        } else if (response.data.status_code === 401) {
          this.loader = false;
        } else {
          this.stoploader();
          this.showAlertError(`Failed: ${response.data.message}`);
        }
        console.log("Update", response);
      } catch (e) {
        console.error(e);
        this.showAlertError(`Failed: Technical Error please try again later.`);
        this.loader = false;
      }
      this.closeDialog();
    },

    async downloadExcelsheet() {
      if (this.BankSummary) {
        this.exportToExcel(
          this.dessertHeaders,
          this.BankSummary,
          "Deactive_Bank_List"
        );
      } else if (this.ActiveBankSummary) {
        this.exportToExcel(
          this.activeHeaders,
          this.ActiveBankSummary,
          "Active_Bank_list"
        );
      }
    },

    async getAllBanks() {
      this.loader = true;
      try {
        const response = await partnerService.getPartnerBankList(
          this.$route.query.parent_partner_id,
          this.inactivePaymentMode,
          false
        );
        if (response.data.status_code === 200) {
          this.BankSummary = response.data.data.reverse();
          this.stoploader();
        } else if (response.data.status_code === 401) {
          this.BankSummary = [];
        } else {
          this.stoploader();
          this.showAlertError(`Failed: ${response.data.message}`);
          this.BankSummary = [];
        }
        console.log("All Banks", response);
      } catch (e) {
        console.error(e);
        this.showAlertError(`Failed: Technical Error please try again later.`);
        this.loader = false;
        this.BankSummary = [];
      }
    },
    async getAllActiveBanks() {
      try {
        this.loader = true;
        const response = await partnerService.getPartnerBankList(
          this.$route.query.parent_partner_id,
          this.paymentMode,
          true
        );
        if (response.data.status_code === 200) {
          this.ActiveBankSummary = response.data.data.reverse();
          this.stoploader();
        } else if (response.data.status_code === 401) {
          this.ActiveBankSummary = [];
        } else {
          this.stoploader();
          this.showAlertError(`Failed: ${response.data.message}`);
          this.ActiveBankSummary = [];
        }
        console.log("All Banks", response);
      } catch (e) {
        console.error(e);
        this.showAlertError(`Failed: Technical Error please try again later.`);
        this.loader = false;
        this.ActiveBankSummary = [];
      }
    },
    getAllData() {
      this.loader = true;
      this.getAllBanks();
      this.getAllActiveBanks();
      this.stoploader();
    },
    async partnerPaymentMode() {
      try {
        this.loader = true;
        const response = await partnerService.getPartnerPaymentMode(
          this.$route.query.parent_partner_id
        );
        if (response.data.status_code === 200) {
          this.loader = false;
          this.method_options = response.data.data[0].map((i) => {
            return {
              txt: i.value,
              val: i.value_code,
            };
          });
        } else {
          this.method_options = [];
          this.loader = false;
        }
        console.log("Payment Modes", response);
      } catch (e) {
        console.error(e);
        this.loader = false;
        console.error(e);
      }
    },

    navBranchList(item) {
      this.$router.push({
        name: "partnerBranch Summary",
        params: item,
      });
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";
.width-anchor {
  width: 200px !important;
}

.required:after {
  content: " *";
  color: red;
}
</style>
